import Swal from "sweetalert2";
import { axiosConfig } from "../Configuration/axios/axiosConfiguration";
import { toast } from "react-toastify";

export const addToBasket = async (itemId, type, count) => {
    if (count === undefined) count = 1;
    let response = false;
    await axiosConfig
        .post("api/ShoppingCart", {
            contentId: itemId,
            contentType: type,
            count: count,
        })
        .then((res) => {
            response = true;
            Swal.fire(
                res.data.message ? "موفقیت" : "خطا",
                res.data.message
                    ? "با موفقیت به سبد خرید اضافه شد"
                    : res.data.message,
                res.data.message ? "success" : "error"
            );
        })
        .catch((err) => {
            debugger;
            if (err.response.status == 401) {
                toast.warning("وارد حساب کاربری خود شوید", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else Swal.fire("خطا", err.response.data.message, "error");
        });
    return response;
};
